import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Tabs from '../../components/tabs';
import { updateOnboardingState } from '../../containers/user-onboarding-state/actions';

class Onboarding extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  updateOnboardingState = () => {
    this.props.onUpdateOnboardingState({ page: 'dashboard', onboardingState: 'overview', callback: this.changeUrlPath('/') });
  }

  changeUrlPath = path => () => this.context.router.push(path);

  render() {
    return (
      <div className="page">
        <Tabs title="My Campaigns" tabsStyle={'tabs'} hideTabs />
        <div className="page-content">
          <div className="grid">
            <div className="box centered">
              <div className="box-content-one">
                <div className="box-content-two">
                  <div className="box-content-three">
                    <div className="spacer" />
                    <h2>What are we waiting for?<br />Let’s get started!</h2>
                    <div className="spacer large" />
                    <img src="/loudspeaker.svg" alt="let's get started" />
                    <div className="spacer large" />
                    <p>
                      Add a campaign to begin working on campaigns and inviting people to collaborate with you on Dyzio.
                    </p>
                    <div className="spacer" />
                    <button className="large rose wide">
                      <p>Create a campaign!</p>
                    </button>
                    <div className="spacer" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="onboarding-modal">
            <div className="onboarding-content">
              <div className="flex">
                <h1>Get started</h1>
              </div>
              <div className="flex">
                <div className="box">
                  <img src="/icons/rocket-seagreen.svg" alt="rocket" />
                  <div className="spacer small" />
                  <h3>Create a campaign</h3>
                  <div className="spacer small" />
                  <p className="small">Run your campaigns through dyzio</p>
                  <div className="link">
                    <p className="small">
                      <a href="/dashboard">Get started</a>
                    </p>
                  </div>
                </div>
                <div className="box">
                  <img src="/icons/tracking.svg" alt="rocket" />
                  <div className="spacer small" />
                  <h3>Track live video</h3>
                  <div className="spacer small" />
                  <p className="small">
                    Get live analytics on influencer videos{' '}
                  </p>
                  <div className="link">
                    <p className="small"><a href="/analytics">Get started</a></p>
                  </div>
                </div>
                <div className="box">
                  <img src="/icons/group.svg" alt="rocket" />
                  <div className="spacer small" />
                  <h3 className="light">Build your influencer database</h3>
                  <div className="spacer small" />
                  <p className="small light">
                    Record the details of the influencers you work with for you and your team
                  </p>
                  <div className="link">
                    <p className="small">Coming soon...</p>
                  </div>
                </div>
              </div>
              <div className="flex">
                <button onClick={this.updateOnboardingState} className="medium wide">skip</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({

});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onUpdateOnboardingState: data => dispatch(updateOnboardingState(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Onboarding);



/** WEBPACK FOOTER **
 ** ./src/components/onboarding/index.js
 **/